import React from 'react';
import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import fields from 'components/forms/application_original/fields';
import {bootstrapOldForm} from 'components/forms/AutoSection';
import FocusApplication from 'components/payment/FocusApplication';
import {PBold} from 'components/TypographyShortcuts';

const Endorsements = ({applicationType, ...props}) => {
    const {initialValues, schema} = bootstrapOldForm('Endorsements', fields);

    return (
        <Section {...props} {...{schema, initialValues}}>
            <FocusApplication {...applicationType} />
            <PBold>
                Final Questions to make your application even faster at the NMC
            </PBold>
            <AutoField field={fields.endorsement_text} name='endorsement_text' />
        </Section>
    );
};

export default Endorsements;
